// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"BackButtonHeader_headerContainer__3k6rL","arrowIcon":"BackButtonHeader_arrowIcon__Q8NHA","linkText":"BackButtonHeader_linkText__XBbp5"};